import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { ExternalLink } from '../../components';

import css from './PrivacyPolicy.module.css';

const PrivacyPolicy = props => {
  const { rootClassName, className } = props;
  const classes = classNames(rootClassName || css.root, className);

  return (
    <div className={classes}>
      <p className={css.subheading}><strong>Introduction</strong></p>
      <p>
        At ROTATE NZ LIMITED ("we", "us", or "our"), we take your privacy seriously
        — and we believe in being upfront with how we handle your personal information.
        This Privacy Policy explains what we collect, why we collect it, and how
        we protect your information when you use
        &nbsp;
        <ExternalLink
          className={css.inlineLink}
          key="rotatenow_root" href="https://www.rotatenow.co.nz">
          www.rotatenow.co.nz
        </ExternalLink>
        &nbsp;
        (the "Site").
      </p>

      <p className={css.subheading}><strong>1. What We Collect and Why</strong></p>
      <p>
        When you use ROTATE, we may ask you for a few details to help things run
        smoothly — like your:
      </p>
      <ul>
        <li>Name</li>
        <li>Email address</li>
        <li>Delivery address</li>
        <li>Phone number</li>
      </ul>
      <p>
        This information is used to complete sales, help buyers and sellers connect,
        and make your experience as seamless as possible.
      </p>

      <p className={css.subheading}><strong>2. How We Use Your Information</strong></p>
      <p>We use your personal info to:</p>
      <ul>
        <li>Run and improve the ROTATE platform</li>
        <li>Help buyers and sellers communicate clearly and safely</li>
        <li>Resolve issues or disputes quickly</li>
        <li>Keep you in the loop with updates (only if you opt in)</li>
      </ul>

      <p className={css.subheading}><strong>3. Sharing Information (Only When Needed)</strong></p>
      <p>We never sell your data — ever.</p>
      <p>
        But because ROTATE is a marketplace, some information (like your name or
        address) may be shared only when necessary to complete a transaction or
        sort out an issue.
      </p>
      <p>
        We may also share your information with trusted third-party services that help
        us run the site (like payment providers), or when legally required to do so.
      </p>

      <p className={css.subheading}><strong>4. Cookies & Tracking</strong></p>
      <p>We use cookies to:</p>
      <ul>
        <li>Remember your preferences</li>
        <li>Help the site function properly</li>
        <li>Understand how people use ROTATE so we can improve it</li>
      </ul>
      <p>You can disable cookies in your browser settings if you’d prefer.</p>

      <p className={css.subheading}><strong>5. Keeping Your Data Safe</strong></p>
      <p>
        We use security measures to protect your information — but as with anything
        online, no system is 100% bulletproof. That said, we’re committed to keeping
        your data as safe as we possibly can.
      </p>

      <p className={css.subheading}><strong>6. Your Privacy Rights</strong></p>
      <p>You’re always in control. You can:</p>
      <ul>
        <li>Ask what personal data we have on you</li>
        <li>Request a correction or deletion</li>
        <li>Withdraw consent (where relevant)</li>
      </ul>

      <p className={css.subheading}><strong>7. Third-Party Links</strong></p>
      <p>
        Sometimes we link to other websites — but we’re not responsible for their
        privacy practices. It’s always a good idea to read their policies too.
      </p>

      <p className={css.subheading}><strong>8. Updates to This Policy</strong></p>
      <p>
        We may make changes to this Privacy Policy from time to time. When we do,
        we’ll update the date and post it on the site. If the changes are big,
        we’ll let you know.
      </p>

      <p className={css.subheading}><strong>9. Contact Us</strong></p>
      <p>Got questions? We’re happy to help.</p>
      <p>
        Email us anytime at:
        &nbsp;
        <ExternalLink
          className={css.inlineLink}
          key="rotatenow_email"
          href="mailto:hq@rotatenow.co.nz"
        >
          hq@rotatenow.co.nz
        </ExternalLink>
      </p>

    </div>
  );
};

PrivacyPolicy.defaultProps = {
  rootClassName: null,
  className: null,
};

const { string } = PropTypes;

PrivacyPolicy.propTypes = {
  rootClassName: string,
  className: string,
};

export default PrivacyPolicy;
